import { render } from "./LinkCustomerToDiscountGroupModal.html?vue&type=template&id=259cce97&scoped=true"
import script from "./LinkCustomerToDiscountGroupModal.js?vue&type=script&lang=js"
export * from "./LinkCustomerToDiscountGroupModal.js?vue&type=script&lang=js"

import "./LinkCustomerToDiscountGroupModal.css?vue&type=style&index=0&id=259cce97&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-259cce97"]])

export default __exports__